import { api } from '@services';

import Product, { IProduct, IProductApiModel } from '@models/Product.model';

interface INewProduct {
  isTemp?: boolean;
  name?: string;
  model?: string;
  description?: string;
  manufacturerId?: string;
}
interface IPatchProductVariables {
  data: INewProduct;
}
const createProduct = async ({
  data,
}: IPatchProductVariables): Promise<IProduct> => {
  // Always that user create a new product using the Beam Ui, will be Temporary
  data.isTemp = true;
  const { data: product } = await api.post<IProductApiModel>(
    `/products/`,
    data,
  );

  return Product.fromApiModel(product);
};

export { createProduct };
